export function setToken(tokenKey, token) {
  return localStorage.setItem(tokenKey, token);
}

export function setDescription(descriptionKey, description) {
  return localStorage.setItem(descriptionKey, description);
}
export function setIds(idsKey, ids) {
  return localStorage.setItem(idsKey, ids);
}
export function setMenu(menuKey, menu) {
  return localStorage.setItem(menuKey, menu);
}

export function setName(nameKey, name) {
  return localStorage.setItem(nameKey, name);
}

export function getToken(tokenKey) {
  return localStorage.getItem(tokenKey);
}
export function getDescription(descriptionKey) {
  return localStorage.getItem(descriptionKey);
}export function getIds(idsKey) {
  return localStorage.getItem(idsKey);
}
export function getMenu(menuKey) {
  return localStorage.getItem(menuKey);
}
export function getName(nameKey) {
  return localStorage.getItem(nameKey);
}
export function removeToken(tokenKey) {
  return localStorage.removeItem(tokenKey);
}

export function removeMenu(menuKey) {
  return localStorage.removeItem(menuKey);
}
export function removeName(nameKey) {
  return localStorage.removeItem(nameKey);
}
